/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from "prop-types";
import {Button, Icon, Pane, RadioCheckGroup, Tabs} from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import ModalDialog from '../../widgets/ModalDialog/ModalDialog';
import AxiosClient from "../../../_helpers/http.helper";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import  { impersonateUser } from '../../../session.initialize';

export default class UpdateUserProfile extends React.Component {

    static get propTypes() {
        return {
            showModal: PropTypes.bool.isRequired,
            profile: PropTypes.object.isRequired,
            showSecondModal: PropTypes.func.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            usableRoles: [
                {
                    roleId: 10,
                    name: "Project Specialist"
                },
                {
                    roleId: 11,
                    name: "Print Vendor"
                },
                {
                    roleId: 12,
                    name: "Print Admin"
                },
                {
                    roleId: 15,
                    name: "LSA"
                },
                {
                    roleId: 16,
                    name: "Content Admin"
                },
                {
                    roleId: 2,
                    name: "Instructor"
                },
                {
                    roleId: 8,
                    name: "Sales Rep"
                },
            ],
            updatedRoles: [],
            currentGeos: [
                {
                    geoId: 0,
                    code: "US"
                },
                {
                    geoId: 1,
                    code: "CA"
                },
            ],
            updatedGeos: [],
            context: {},
            selectedTab: 0,
            showSecondModal: false
        };
    }

    componentDidMount() {
        this.handleRoles();
        this.handleGeos();
        this.handleContext();
    }

    changeRoles = (userId, roles) => {
        const changeRolesUrl = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.userRoles,
            {
                userId: userId
            }
        );
        AxiosClient.put(changeRolesUrl, roles)
            .then(response => {
                this.props.hideModal();
                this.props.showSecondModal("Success", "User Roles successfully updated");
                return response.data;
            }).catch((error) => {
                this.props.hideModal();
                this.props.showSecondModal("Error", "An error occurred while updating please try again");
            });
    };

    changeGeos = (userId, geos) => {
        const changeGeosUrl = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.userGeos,
            {
                userId: userId
            }
        );
        AxiosClient.put(changeGeosUrl, geos)
            .then(res => {
                this.props.hideModal();
                this.props.showSecondModal("Success", "User Geos successfully updated");
                return res.data;
            }).catch((error) => {
                this.props.hideModal();
                this.props.showSecondModal("Error", "An error occurred while updating please try again");
            });
    };

    changeContext = (userId, context) => {
        console.log("context: ",context);
        const changeContextUrl = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.userContext,
            {
                userId: userId
            }
        );
        AxiosClient.put(changeContextUrl, context)
            .then(response => {
                this.props.hideModal();
                this.props.showSecondModal("Success", "User Context successfully updated");
                return response.data;
            }).catch((error) => {
                this.props.hideModal();
                this.props.showSecondModal("Error", "Error occurred while updating Context. Please re-check.");
            });
    };

    handleRoles() {
        this.setState(prevState => ({
            updatedRoles: this.props.profile.csgRoles.map(roleName => {

                const usedRole = prevState.usableRoles.find(usableRole => usableRole.name === roleName);
                return usedRole ? usedRole.roleId : null;

            }).filter(roleId => !!roleId),
        }));
    }

    handleGeos() {
        this.setState(prevState => ({
            updatedGeos: this.props.profile.geos.map(geo => {
                const usedGeo = prevState.currentGeos.find(currentGeo => currentGeo.code === geo.geoCode);
                return usedGeo ? usedGeo.code : null;
            }).filter(code => !!code),
        }));
    }

    handleContext() {
        this.setState(({
            context: this.props.profile.geos.reduce((geoMap, geoContext) => {
                const scrubbedStatus = [];

                if (geoContext.scrubbed) {
                    scrubbedStatus.push("scrubbed");
                }
                if (geoContext.unscrubbed) {
                    scrubbedStatus.push("unscrubbed");
                }

                geoMap[geoContext.geoCode] = scrubbedStatus;
                return geoMap;
            }, {})
        }));
    }

    setDefaultGeo() {
        if (this.state.updatedGeos.length) {
            return this.state.updatedGeos;
        } else {
            this.state.updatedGeos.push('US');
            return this.state.updatedGeos;
        }
    }

    checkContext() {
        if( ((this.state.context["CA"] && this.state.context["CA"].length ===0 )) || (this.state.context["US"] && this.state.context["US"].length ===0 ) ){
            return true;
        }
        else{
            return false;
        }
    }

    buildItem = () => {

        return (
            <div className="metadata-item-container">
                <div className="update-user-profile">
                    <Tabs className="pe-col-12" selected={this.state.selectedTab}>
                        <Pane label="Manage Roles">
                            <div className="pe-col-4 sub-header">
                                <RadioCheckGroup
                                    inputType="checkbox"
                                    id="roles"
                                    options={this.state.usableRoles.map(role => ({
                                        value: role.roleId,
                                        label: role.name,
                                        checked: this.state.updatedRoles.includes(role.roleId),
                                        disabled: role.roleId === 2 ? true : ''
                                    }))}
                                    changeHandler={(e) => {
                                        const roleId = Number.parseInt(e.target.value);
                                        this.setState(prevState => ({
                                            updatedRoles: prevState.updatedRoles.includes(roleId) ? prevState.updatedRoles.filter(i => i !== roleId) : [...prevState.updatedRoles, roleId],
                                            selectedTab: 0
                                        }));
                                    }}
                                />
                            </div>

                            <div className="edit-btn">
                                <Button className="pe-btn" onClick={() => {
                                    impersonateUser(this.props.profile.username);
                                }}>Impersonate</Button>
                                <button className="pe-btn" type="reset" onClick={() => {
                                    this.setState({
                                        selectedTab: 0
                                    }, this.handleRoles);
                                }}>Reset
                                </button>
                                <Button type="submit" btnType="primary" onClick={() => {
                                    this.changeRoles(this.props.profile.id, this.state.updatedRoles.map(role => role.toString()));
                                }}>Save
                                </Button>
                            </div>

                        </Pane>

                        <Pane label="Manage Geo">
                            <div className="pe-col-4 sub-header">
                                <RadioCheckGroup
                                    inputType="checkbox"
                                    id="geos"
                                    options={this.state.currentGeos.map(geo => ({
                                        value: geo.code,
                                        label: geo.code,
                                        checked: this.state.updatedGeos.includes(geo.code)
                                    }))}
                                    changeHandler={(e) => {

                                        const code = e.target.value;
                                        this.setState(prevState => ({
                                            updatedGeos: prevState.updatedGeos.includes(code) ? prevState.updatedGeos.filter(i => i !== code) : [...prevState.updatedGeos, code],
                                            selectedTab: 1
                                        }));
                                    }}
                                />
                            </div>
                            <div className="edit-btn">
                                <Button className="pe-btn"  onClick={() => {
                                    impersonateUser(this.props.profile.username);
                                }}>Impersonate</Button>                                
                                <button className="pe-btn" type="reset" onClick={() => {
                                    this.setState({
                                        selectedTab: 1
                                    }, this.handleGeos);
                                }}>Reset</button>
                                <Button type="submit" btnType="primary" onClick={() => {
                                    this.changeGeos(this.props.profile.id, this.setDefaultGeo());
                                }}>Save</Button>
                            </div>
                        </Pane>

                        <Pane className="pe-col-4" label="Manage Context">
                            <div className="pe-col-4 sub-header">

                                <span>US :</span>
                                <RadioCheckGroup
                                    inputType="checkbox"
                                    id="context-us"
                                    options={
                                        [
                                            {
                                                value: "scrubbed",
                                                label: "Scrubbed",
                                                checked: this.state.context["US"] && this.state.context["US"].includes("scrubbed"),
                                                disabled: !this.state.updatedGeos.includes("US")
                                            },
                                            {
                                                value: "unscrubbed",
                                                label: "Unscrubbed",
                                                checked: this.state.context["US"] && this.state.context["US"].includes("unscrubbed"),
                                                disabled: !this.state.updatedGeos.includes("US")
                                            }
                                        ]}
                                    changeHandler={(e) => {
                                        this.setState({
                                            selectedTab: 2
                                        });

                                        const checkedContext = e.target.value;
                                        this.setState(prevState => {
                                            const currentContext = prevState.context;

                                            if (!currentContext["US"]) {
                                                currentContext["US"] = [];
                                            }

                                            currentContext["US"] = currentContext["US"].includes(checkedContext)
                                                ? currentContext["US"].filter(contextName => contextName !== checkedContext)
                                                : [...currentContext["US"], checkedContext];

                                            return {
                                                context: currentContext
                                            };
                                        });
                                    }}
                                />

                                <span>CA :</span>
                                <RadioCheckGroup
                                    inputType="checkbox"
                                    id="context-ca"
                                    options={
                                        [
                                            {
                                                value: "1",
                                                label: "Scrubbed",
                                                checked: this.state.context["CA"] && this.state.context["CA"].includes("scrubbed"),
                                                disabled: !this.state.updatedGeos.includes("CA")

                                            },
                                            {
                                                value: "2",
                                                label: "Unscrubbed",
                                                checked: this.state.context["CA"] && this.state.context["CA"].includes("unscrubbed"),
                                                disabled: true
                                            }
                                        ]}
                                    changeHandler={(e) => {
                                        this.setState({
                                            selectedTab: 2
                                        });

                                        let checkedContext = "";
                                        if(e.target.value === "1"){
                                            checkedContext = "scrubbed";
                                        }else if(e.target.value ==="2") {
                                            checkedContext = "Unscrubbed";
                                        }

                                        this.setState(prevState => {
                                            const currentContext = prevState.context;

                                            if (!currentContext["CA"]) {
                                                currentContext["CA"] = [];
                                            }

                                            currentContext["CA"] = currentContext["CA"].includes(checkedContext)
                                                ? currentContext["CA"].filter(contextName => contextName !== checkedContext)
                                                : [...currentContext["CA"], checkedContext];

                                            return {
                                                context: currentContext
                                            };
                                        });
                                    }}
                                />
                            </div>
                            <div className="edit-btn">
                                <Button className="pe-btn" onClick={() => {
                                    impersonateUser(this.props.profile.username);
                                }}>Impersonate</Button>
                                <Button className="pe-btn" type="reset" onClick={() => {
                                    this.setState({
                                        selectedTab: 2
                                    }, this.handleContext);
                                }}>Reset</Button>
                                <Button type="submit" btnType="primary" disabled={this.checkContext()} onClick={() => {
                                    this.changeContext(this.props.profile.id, this.state.context);
                                }}>Save</Button>
                            </div>
                        </Pane>
                    </Tabs>
                </div>
            </div>
        );
    };

    render() {
        const { showModal, hideModal } = this.props;
        return (
            <ModalDialog
                title={"Update User Profile"}
                showModal={showModal}
                onSuccess={this.onSuccess}
                showFooter={false}
                onCancel={hideModal}>
                {this.buildItem()}
            </ModalDialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Accounts/UpdateUserProfile.js